/**
 * Default order of cards
 * @type {*[]}
 */

const defaultOrder = [
  {
    name: 'ACTIVITY',
    hidden: false,
  },
  {
    name: "WEIGHT",
    hidden: false
  },
  {
    name: "BLOOD_GLUCOSE",
    hidden: false
  },
  {
    name: "SLEEP",
    hidden: false
  },
  {
    name: "CHOLESTEROL",
    hidden: false
  },
  {
    name: "MEDICATION",
    hidden: false
  },
  {
    name: "BLOOD_PRESSURE",
    hidden: false
  },
  {
    name: "MOOD",
    hidden: false
  },
  {
    name: "KETONES",
    hidden: false
  },
  {
    name: "NUTRITION",
    hidden: false
  },
  {
    name: "INSULIN",
    hidden: false
  }
];


import SettingsApi from "../../api/Settings"

export default {
  data() {
    return {
      isCardOrderReady: false,
      order: defaultOrder
    }
  },
  mounted() {
    let self = this;
    if (self.$store.state.cardOrder.length > 0) {
      self.order = self.$store.state.cardOrder;
      self.isCardOrderReady = true;
    }
    else SettingsApi.getCardOrder()
      .then(function (response) {
        self.order = response.data;
        self.isCardOrderReady = true;
        self.$store.commit('setCardOrder', response.data);
      })
  },
  computed: {
    chunkedOrder() {
      let self = this;
      let filteredArray = self.order.filter(function (item) {
        return item.hidden === false
      });
      return _.chunk(filteredArray, 4);
    },
    desktopWidth() {
      let self = this;
      if (self.chunkedOrder.length === 3) {
        return "33";
      }
      if (self.chunkedOrder.length === 2) {
        return "50";
      }
      if (self.chunkedOrder.length === 1) {
        return "100"
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/CardOrderMixin/index.js